"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignBlocks = exports.CampaignTemplateType = exports.CampaignTemplates = void 0;
var CampaignTemplates;
(function (CampaignTemplates) {
    CampaignTemplates["DefaultTemplate"] = "Default template";
    CampaignTemplates["InstructorTemplate"] = "Instructor template";
    CampaignTemplates["AffiliateTemplate"] = "Affiliate template";
})(CampaignTemplates = exports.CampaignTemplates || (exports.CampaignTemplates = {}));
var CampaignTemplateType;
(function (CampaignTemplateType) {
    CampaignTemplateType["Instructor"] = "instructor";
    CampaignTemplateType["Affilitate"] = "affiliate";
    CampaignTemplateType["Default"] = "default";
})(CampaignTemplateType = exports.CampaignTemplateType || (exports.CampaignTemplateType = {}));
var CampaignBlocks;
(function (CampaignBlocks) {
    CampaignBlocks["LoopVideoBlock"] = "Loop video block";
    CampaignBlocks["CtaWithImgBlock"] = "Call to action with image block";
    CampaignBlocks["AffiliateCtaWithImgBlock"] = "Affiliate call to action with image block";
    CampaignBlocks["CommentsBlock"] = "Comments block";
    CampaignBlocks["CommentBlock"] = "Comment block";
    CampaignBlocks["CtaWithFeaturesBlock"] = "Call to action with features block";
    CampaignBlocks["FeatureBlock"] = "Feature block";
    CampaignBlocks["AnimatedSessionsBlock"] = "Animated sessions block";
    CampaignBlocks["AnimatedInstructorsBlock"] = "Animated instructors block";
    CampaignBlocks["CtaWithTextBlock"] = "Call to action with text block";
    CampaignBlocks["FaqBlock"] = "FAQ Block";
})(CampaignBlocks = exports.CampaignBlocks || (exports.CampaignBlocks = {}));
//# sourceMappingURL=CampaignTemplate.js.map